
<!--<app-header *ngIf="!globalService.isIndex && globalService.showHeader"></app-header>-->
<router-outlet></router-outlet>
<!--<app-footer class="footer" *ngIf="!globalService.isIndex && globalService.showFooter"></app-footer>-->





// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/app.component.html